import { useContext, useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import { IoSparklesOutline } from "react-icons/io5";
import { FaArrowRightLong, FaCheck } from "react-icons/fa6";
import { AppContext } from "../App";

import bg from "../assets/adventure.jpg";

export default function HomeBanner4() {
  const appContext = useContext(AppContext);

  const [ready, setReady] = useState(false);

  const steps = [
    {
      title: "Tell Us Your Travel Style",
      text: "Share dates, interests, pace, and budget. We shape an itinerary around what matters most to you.",
    },
    {
      title: "Receive a Tailor-Made Plan",
      text: "Get route options, lodges, and activity flow with transparent inclusions and practical guidance.",
    },
    {
      title: "Travel with Local Experts",
      text: "From airport pickup to final farewell, our team handles logistics so you can stay present in the moment.",
    },
    {
      title: "Capture Lifetime Memories",
      text: "Return home with meaningful experiences from Tanzania's parks, mountains, coastlines, and communities.",
    },
  ];

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container py-5 text-center">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <section
      className="MainBodySection py-5"
      style={{
        backgroundImage: `linear-gradient(rgba(7,26,31,.6), rgba(7,26,31,.45)), url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="container">
        <div className="text-center mb-4" data-aos="zoom-in">
          <div className="section-heading-pro section-heading-pro--center section-heading-pro--light">
            <span className="section-heading-pro__rail" />
            <h2 className="section-heading-pro__title text-light font-bold mb-2">
              How Your Journey Comes Together
            </h2>
          </div>
          <p className="mb-0" style={{ color: "#c8d5e4" }}>
            A clear process, expert guidance, and smooth logistics from first message to final day in Tanzania.
          </p>
        </div>

        <div className="row g-4 align-items-stretch">
          <div className="col-lg-8">
            <div className="row g-3">
              {steps.map((step, index) => (
                <div key={step.title} className="col-md-6">
                  <article
                    data-aos={index % 2 === 0 ? "fade-down" : "fade-down"}
                    data-aos-delay={index * 70}
                    style={{
                      height: "100%",
                      borderRadius: 20,
                      border: "1px solid transparent",
                      background: "linear-gradient(rgba(255,255,255,.08), rgba(255,255,255,.08)) padding-box, linear-gradient(140deg, rgba(242,196,94,.5), rgba(129,184,171,.4)) border-box",
                      backdropFilter: "blur(3px)",
                      padding: "18px 16px",
                      color: "#fff",
                      boxShadow: "0 14px 30px rgba(3,15,23,.2)",
                    }}
                  >
                    <p
                      className="d-inline-flex align-items-center gap-2 font-semi-bold"
                      style={{ color: "#f2c45e", fontSize: 12, letterSpacing: 1, textTransform: "uppercase" }}
                    >
                      <IoSparklesOutline size={14} />
                      Step {index + 1}
                    </p>
                    <h3 className="font-semi-bold mt-1 mb-2" style={{ fontSize: 20 }}>
                      {step.title}
                    </h3>
                    <p className="mb-0" style={{ color: "#cfdeea", lineHeight: 1.65 }}>
                      {step.text}
                    </p>
                  </article>
                </div>
              ))}
            </div>
          </div>

          <div className="col-lg-4" data-aos="fade-up" data-aos-delay="120">
            <article
              style={{
                height: "100%",
                borderRadius: 22,
                border: "1px solid transparent",
                background: "linear-gradient(180deg, rgba(255,255,255,.13), rgba(255,255,255,.05)) padding-box, linear-gradient(130deg, rgba(242,196,94,.52), rgba(141,168,208,.42)) border-box",
                padding: 20,
                color: "#fff",
                display: "flex",
                flexDirection: "column",
                boxShadow: "0 16px 34px rgba(6,18,29,.22)",
              }}
            >
              <p className="font-semi-bold mb-2" style={{ color: "#f2c45e", letterSpacing: 1, textTransform: "uppercase", fontSize: 12 }}>
                Travel Confidence
              </p>
              <h3 className="font-bold mb-3" style={{ fontSize: 28, lineHeight: 1.25 }}>
                Ready to Build Your Tanzania Itinerary?
              </h3>
              <div className="d-flex flex-column gap-2 mb-4">
                {["Fast response on WhatsApp", "Flexible accommodation options", "24/7 trip support while in Tanzania"].map((item) => (
                  <p key={item} className="mb-0 d-flex align-items-start" style={{ gap: 8, color: "#d8e6f2" }}>
                    <FaCheck style={{ marginTop: 5, color: "#f2c45e" }} />
                    <span>{item}</span>
                  </p>
                ))}
              </div>
              <a
                onClick={()=> appContext.navTo({item:'contact_us'})}
                className="btn font-semi-bold d-inline-flex align-items-center mt-auto"
                style={{
                  width: "fit-content",
                  borderRadius: 12,
                  textDecoration: "none",
                  color: "#102132",
                  background: "#f2c45e",
                  padding: "10px 14px",
                  gap: 8,
                }}
              >
                Start Planning
                <FaArrowRightLong size={15} />
              </a>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}
